<template>
  <div id="contenedor-boton-problema-resuelto">
      <v-row justify="center">
        <v-btn
          icon
          @click="mostrarConfirmacion = !mostrarConfirmacion">
          <v-icon color="info"> mdi-check-bold </v-icon>
        </v-btn>
      </v-row>
      <v-dialog
      v-if="mostrarConfirmacion"
      v-model="mostrarConfirmacion"
      width="500">
        <v-card>
          <v-card-title class="secondary--text"> Marcar como Resuelto </v-card-title>
          <v-card-text>
            <span class="secondary--text">
              ¿Desea marcar como resuelto el probelma del frente:
              {{contratoActividad.frente.descripcion}}?
            </span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <custom-button
              @click="mostrarConfirmacion = !mostrarConfirmacion"
              tipo="formCancelar"
              label="Cancelar"
              class="mr-3"
            >
            </custom-button>
            <custom-button
              @click="mixMarcarComoProblemaResuelto"
              :disabled="enviandoFormulario"
              tipo="formAceptar"
              label="Aceptar"
            >
            </custom-button>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import mixActividadesProblemas from './mixActividadesProblemas';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'BotonMarcarProblemaResuelto',
  mixins: [mixActividadesProblemas],
  props: {
    contratoActividad: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
      mostrarConfirmacion: false,
    };
  },
  methods: {
    cerrar() {
      this.mostrarConfirmacion = false;
    },
  },

};
</script>

<style>

</style>
